import { apiSlice } from './apiSlice';

export const welfareCheckAdminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGlobalWelfareCheckSettings: builder.query({
      query: () => ({
        url: '/welfare-check-settings/global/',
        method: 'GET',
      }),
      providesTags: ['WelfareCheckSettings'],
    }),
    updateGlobalWelfareCheckSettings: builder.mutation({
      query: (settings) => ({
        url: '/welfare-check-settings/global/',
        method: 'PUT',
        body: { ...settings },
      }),
      invalidatesTags: ['WelfareCheckSettings'],
    }),
    triggerWelfareCheckPoll: builder.mutation({
      query: () => ({
        url: '/welfare-check-monitor/run/',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetGlobalWelfareCheckSettingsQuery,
  useUpdateGlobalWelfareCheckSettingsMutation,
  useTriggerWelfareCheckPollMutation,
} = welfareCheckAdminApiSlice;
